// extracted by mini-css-extract-plugin
export default {"container":"MbcDetailsDesktop__container___IsCwm","header":"MbcDetailsDesktop__header___WDGpx","avatar":"MbcDetailsDesktop__avatar___DmWxQ"};